// Doctor document types — shared between DoctorProfilePage and DocumentUploadModal.
// Keys MUST match backend ALLOWED_DOCUMENT_TYPES in admin.routes.js.
// MIME types and size limits MUST match backend DOCUMENT_RULES in admin.routes.js.
// If you change anything here, change the backend too.

export const DOCUMENT_TYPES = [
  {
    key: 'medical_association_cert',
    label: 'Βεβαίωση εγγραφής από Ιατρικό Σύλλογο',
    hasExpiry: true,
    requiresExpiryAlert: true,
    acceptedMimeTypes: ['application/pdf'],
    maxBytes: 10 * 1024 * 1024,
  },
  {
    key: 'liability_insurance',
    label: 'Ασφαλιστήριο επαγγελματικής ευθύνης',
    hasExpiry: true,
    requiresExpiryAlert: true,
    acceptedMimeTypes: ['application/pdf'],
    maxBytes: 10 * 1024 * 1024,
  },
  {
    key: 'cooperation_contract',
    label: 'Σύμβαση Συνεργασίας',
    hasExpiry: false,
    requiresExpiryAlert: false,
    acceptedMimeTypes: ['application/pdf'],
    maxBytes: 10 * 1024 * 1024,
  },
  {
    key: 'gdpr_agreement',
    label: 'GDPR Agreement',
    hasExpiry: false,
    requiresExpiryAlert: false,
    acceptedMimeTypes: ['application/pdf'],
    maxBytes: 10 * 1024 * 1024,
  },
  {
    key: 'id_document',
    label: 'Ταυτότητα / ID',
    hasExpiry: false,
    requiresExpiryAlert: false,
    acceptedMimeTypes: ['application/pdf', 'image/png', 'image/jpeg'],
    maxBytes: 5 * 1024 * 1024,
  },
  {
    key: 'signature',
    label: '✍️ Υπογραφή Ιατρού',
    hasExpiry: false,
    requiresExpiryAlert: false,
    acceptedMimeTypes: ['image/png', 'image/jpeg'],
    maxBytes: 2 * 1024 * 1024,
  },
  {
    key: 'stamp',
    label: '🔖 Σφραγίδα Ιατρού',
    hasExpiry: false,
    requiresExpiryAlert: false,
    acceptedMimeTypes: ['image/png', 'image/jpeg'],
    maxBytes: 2 * 1024 * 1024,
  },
];

// Helper: find the config object for a given document type key.
export function getDocumentTypeConfig(key) {
  return DOCUMENT_TYPES.find((dt) => dt.key === key) || null;
}
